var _rect, _rect2, _rect3, _rect4, _g, _g2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSw(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sw",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 512,
    height: 512,
    fill: "#f0f0f0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 512,
    height: 135.869
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 512,
    height: 135.847,
    transform: "translate(0 376.153)",
    fill: "#496e2d"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 512,
    height: 172.199,
    transform: "translate(0 169.906)",
    fill: "#a2001d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M356.9,81.712,318.524,64,256,205.572,193.476,64,155.1,81.712,232.726,256,155.1,430.288,193.476,448,256,306.428,318.524,448,356.9,430.288,279.274,256Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M282.063,98.4A298.224,298.224,0,0,0,256,72.855,298.225,298.225,0,0,0,229.937,98.4V413.6A298.166,298.166,0,0,0,256,439.145a298.166,298.166,0,0,0,26.063-25.55Z",
    fill: "#f0f0f0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M185.56,158.848v194.3c15.7,27.814,34.911,50.612,49.308,65.727V93.122C220.471,108.236,201.257,131.033,185.56,158.848Z",
    fill: "#a2001d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M326.44,158.848c-15.7-27.814-34.911-50.612-49.308-65.726V418.88c14.4-15.116,33.611-37.914,49.308-65.727Z",
    fill: "#a2001d"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M326.44,158.848v194.3c15.892-28.161,28.176-61.46,28.176-97.151S342.332,187.01,326.44,158.848Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M185.56,158.848v194.3c-15.892-28.161-28.176-61.46-28.176-97.151S169.668,187.01,185.56,158.848Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSw);
export default __webpack_public_path__ + "static/media/sw.603659e0bbf50b8023991785229080d0.svg";
export { ForwardRef as ReactComponent };